import React from 'react';

const MessageBox = ({ message, type = 'error', onDismiss }) => {
  if (!message) return null;
  const bgColor =
    type === 'error'
      ? 'bg-red-100 border-red-400 text-red-700'
      : 'bg-green-100 border-green-400 text-green-700';

  return (
    <div className={`border px-4 py-3 rounded-lg relative ${bgColor}`} role="alert">
      <span className="block sm:inline">{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="absolute top-0 bottom-0 right-0 px-4 py-3"
        >
          &times;
        </button>
      )}
    </div>
  );
};

export default MessageBox;
